var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('small',{staticClass:"main-footer__text"},[_vm._v("©2019 COLORWAY GRAPHICS LTD. ALL RIGHTS RESERVED")])])}]

export { render, staticRenderFns }